
import { Link } from 'react-router-dom'
import './trainers.css'

const solutions = [
  {
    number: '01',
    title: 'Mantenedores de datos (CRUD)',
    description:
      'Desarrollo de aplicaciones para crear, consultar, actualizar y eliminar registros mediante interfaces intuitivas y procesos controlados.',
    tags: ['CRUD', 'Formularios', 'Validaciones']
  },
  {
    number: '02',
    title: 'Sistemas de gestión institucional',
    description:
      'Soluciones para administrar programas, proyectos, beneficiarios, establecimientos y otros procesos de organizaciones públicas y privadas.',
    tags: ['Gestión', 'Procesos', 'Registros']
  },
  {
    number: '03',
    title: 'Bases de datos y arquitectura',
    description:
      'Diseño de estructuras de información, relaciones entre entidades y mecanismos de consulta e integración de datos.',
    tags: ['PostgreSQL', 'SQL', 'Modelamiento']
  },
  {
    number: '04',
    title: 'Usuarios, roles y seguridad',
    description:
      'Implementación de autenticación, perfiles de acceso, validación de operaciones y controles de seguridad según los requisitos institucionales.',
    tags: ['Autenticación', 'Permisos', 'Seguridad']
  },
  {
    number: '05',
    title: 'Reportes y tableros de gestión',
    description:
      'Herramientas para consultar registros, generar reportes, visualizar indicadores y facilitar el seguimiento de procesos.',
    tags: ['Indicadores', 'Dashboards', 'Reportes']
  },
  {
    number: '06',
    title: 'Integración y automatización',
    description:
      'Conexión entre aplicaciones, intercambio de información y automatización de tareas administrativas repetitivas.',
    tags: ['API', 'Integraciones', 'Automatización']
  }
]

const capabilities = [
  {
    number: '01',
    title: 'Diseño funcional',
    description:
      'Definición de entidades, formularios, reglas de negocio y flujos de trabajo.'
  },
  {
    number: '02',
    title: 'Desarrollo',
    description:
      'Construcción de interfaces, servicios y componentes de acceso a datos.'
  },
  {
    number: '03',
    title: 'Validación',
    description:
      'Pruebas de funcionamiento, integridad de registros y controles de acceso.'
  },
  {
    number: '04',
    title: 'Implementación',
    description:
      'Puesta en marcha, documentación y transferencia de conocimientos.'
  }
]

const Trainers = () => {
  return (
    <main className="demografica-software">

      <section className="software-hero">
        <div className="software-hero__content">
          <p className="software-eyebrow">
            DEMOGRÁFICA · DESARROLLO DE SOFTWARE
          </p>

          <h1>
            Sistemas que organizan datos.
            <span> Soluciones que simplifican la gestión.</span>
          </h1>

          <p className="software-hero__description">
            Diseñamos y desarrollamos aplicaciones informáticas
            a medida para administrar información, optimizar
            procesos institucionales y facilitar el trabajo
            cotidiano con datos.
          </p>

          <div className="software-hero__actions">
            <Link to="/contact" className="software-btn software-btn--primary">
              Solicitar un desarrollo →
            </Link>

            <a href="#software-solutions" className="software-btn software-btn--secondary">
              Explorar soluciones
            </a>
          </div>
        </div>

        <div className="software-hero__visual">
          <div className="software-interface" aria-label="Ejemplo ilustrativo de una interfaz de gestión de datos">
            <div className="software-interface__top">
              <span className="software-interface__dots" aria-hidden="true">
                <i />
                <i />
                <i />
              </span>
              <span>GESTIÓN DE INFORMACIÓN</span>
            </div>

            <div className="software-interface__body">
              <div className="software-interface__heading">
                <div>
                  <small>PLATAFORMA INSTITUCIONAL</small>
                  <strong>Administración de registros</strong>
                </div>
                <span className="software-interface__status">
                  Sistema ilustrativo
                </span>
              </div>

              <div className="software-interface__toolbar">
                <span>Buscar registros...</span>
                <span>+ Nuevo registro</span>
              </div>

              <div className="software-interface__table">
                <div className="software-interface__row software-interface__row--header">
                  <span>ID</span>
                  <span>Registro</span>
                  <span>Estado</span>
                </div>
                {[
                  ['001', 'Registro de ejemplo A'],
                  ['002', 'Registro de ejemplo B'],
                  ['003', 'Registro de ejemplo C'],
                  ['004', 'Registro de ejemplo D']
                ].map(([id, name]) => (
                  <div className="software-interface__row" key={id}>
                    <span>{id}</span>
                    <span>{name}</span>
                    <span className="software-interface__active">
                      Activo
                    </span>
                  </div>
                ))}
              </div>

              <div className="software-interface__footer">
                CREAR · CONSULTAR · ACTUALIZAR · ELIMINAR
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="software-intro" id="software-solutions">
        <p className="software-eyebrow">SOLUCIONES INFORMÁTICAS</p>

        <h2>
          Tecnología diseñada para
          <span> necesidades reales.</span>
        </h2>

        <p>
          Desde un mantenedor de registros hasta un sistema
          institucional de mayor complejidad, desarrollamos
          soluciones adaptadas a los procesos, usuarios y
          requerimientos de cada organización.
        </p>
      </section>

      <section className="software-catalog" aria-label="Tipos de soluciones informáticas">
        {solutions.map(({ number, title, description, tags }) => (
          <article className="software-card" key={number}>
            <span className="software-card__number">{number}</span>
            <h3>{title}</h3>
            <p>{description}</p>

            <div className="software-card__tags">
              {tags.map(tag => <span key={tag}>{tag}</span>)}
            </div>
          </article>
        ))}
      </section>

      <section className="software-crud">
        <div className="software-crud__content">
          <p className="software-eyebrow">EL NÚCLEO DE UN MANTENEDOR</p>

          <h2>
            Cuatro operaciones.
            <span> Una gestión más eficiente.</span>
          </h2>

          <p>
            Un sistema CRUD permite administrar el ciclo de
            vida de la información mediante operaciones
            estructuradas y controladas.
          </p>
        </div>

        <div className="software-crud__grid">
          <article>
            <span>C</span>
            <div>
              <h3>Create</h3>
              <p>Crear nuevos registros.</p>
            </div>
          </article>

          <article>
            <span>R</span>
            <div>
              <h3>Read</h3>
              <p>Consultar y buscar información.</p>
            </div>
          </article>

          <article>
            <span>U</span>
            <div>
              <h3>Update</h3>
              <p>Modificar registros existentes.</p>
            </div>
          </article>

          <article>
            <span>D</span>
            <div>
              <h3>Delete</h3>
              <p>Eliminar o desactivar registros según las reglas del sistema.</p>
            </div>
          </article>
        </div>
      </section>

      <section className="software-technology">
        <div>
          <p className="software-eyebrow">TECNOLOGÍAS Y ARQUITECTURA</p>
          <h2>Herramientas modernas, soluciones sostenibles.</h2>
          <p>
            Seleccionamos tecnologías de acuerdo con la escala,
            los requisitos funcionales y las necesidades de
            integración de cada proyecto.
          </p>
        </div>

        <div className="software-technology__tags">
          <span>React</span>
          <span>Python</span>
          <span>Django</span>
          <span>PostgreSQL</span>
          <span>JavaScript</span>
          <span>API REST</span>
          <span>R</span>
          <span>Git</span>
        </div>
      </section>

      <section className="software-process">
        <div className="software-process__heading">
          <p className="software-eyebrow">PROCESO DE DESARROLLO</p>
          <h2>Del requerimiento a una aplicación funcional.</h2>
        </div>

        <div className="software-process__grid">
          {capabilities.map(({ number, title, description }) => (
            <article key={number}>
              <span>{number}</span>
              <h3>{title}</h3>
              <p>{description}</p>
            </article>
          ))}
        </div>
      </section>

      <section className="software-cta">
        <div>
          <p className="software-eyebrow">DESARROLLO A MEDIDA</p>
          <h2>¿Tu organización necesita un sistema de gestión?</h2>
          <p>
            Conversemos sobre tus procesos, necesidades de
            información y objetivos tecnológicos.
          </p>
        </div>

        <Link to="/contact" className="software-btn software-btn--light">
          Solicitar información →
        </Link>
      </section>

    </main>
  )
}

export default Trainers
